<template>
  <div id="biddingMessage"
       class="details-content bidding-message">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title">竞价通知</span>
      </template>
      <template v-slot:content>
        <section class="content customer-info">
          <div class="content-title">竞价通知</div>
          <div class="out-container">
            <div class="table">
              <el-table class="table-container" :data="biddingMessageList">
              <el-table-column>
                <template slot-scope="scope">
                  <div class="table-content">
                    <div>
                      <span :class="scope.row.status === 1?'active':''">{{scope.row.value}}</span>
                      <span :class="scope.row.status === 1?'active activeLeft':'details'" @click="details(scope.row)">点击查看详情</span>
                    </div>
                    <div>
                      {{scope.row.createTime}}
                    </div>
                  </div>
                </template>
              </el-table-column>
              </el-table>
            </div>
            <div class="pagination-tpl-container">
              <pagination-tpl :total="total" :currentPage="currentPage" @queryChange="searchBiddingMessage"></pagination-tpl>
            </div>
          </div>
        </section>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import { setSupplierActivityInfo } from 'common/js/storage';
import { formaTimeToSecond } from 'common/js/util.js';
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import PaginationTpl from 'base/PaginationTpl';
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  data() {
    return {
      // 总条数
      total: 0,
      currentPage: 1,
      // 消息列表
      biddingMessageList: [],
      goodsName:'',
    };
  },
  methods: {
    // 翻页
    searchBiddingMessage(query) {
      this.currentPage = query.currentPage
      this._getBiddingMessageList();
    },
    _getBiddingMessageList() {
      let currentPage = this.currentPage
      supplier.getSupplierNotice(currentPage).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.objectId = i.objectId
            obj.activity = i.activity
            if (i.activity) {
              obj.activity.beginTime = formaTimeToSecond(i.activity.beginTime)
              obj.activity.endTime = formaTimeToSecond(i.activity.endTime)
              obj.activity.biddingBeginTime = formaTimeToSecond(i.activity.biddingBeginTime)
              obj.activity.biddingEndTime = formaTimeToSecond(i.activity.biddingEndTime)
            }
            obj.status = i.isRead
            obj.createTime = formaTimeToSecond(i.createTime)
            obj.statusValue = i.isRead===1?'已读':'未读'
            obj.content = i.content
            obj.value = `[${obj.statusValue}] ${obj.content}`
            arr.push(obj)
          })
          this.biddingMessageList = arr
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      });
    },
    details(row) {
      let id = row.id
      let data = {
        id
      }
      supplier.getSupplierReadNotice(data).then(res => {
        if (res.success) {
          this._getBiddingMessageList();
          setSupplierActivityInfo(row.activity)
          this.$router.push({
            path: "/supplier/spl-bidding/bidding-index/bidding-details",
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      })
    }
  },
  created() {
    this._getBiddingMessageList()
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  }
};
</script>

<style lang="scss" scoped>
.bidding-message {
  .title {
    color: #606266;
    cursor: text;
  }
  .content {
    margin-top: 0px;
    .content-title {
      margin-bottom: 0px;
      padding-left: 16px;
    }
    .out-container {
      padding-left: 0px;
    }
    .has-gutter {
      display: none;
    }
    .table-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 17px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      .details {
        color: #3D74F2;
        margin-left: 10px;
        cursor: pointer;
      }
      .active {
        color: #999;
        cursor: pointer;
      }
      .activeLeft {
        margin-left: 10px;
      }
    }
  }
}
</style>
<style lang="scss">
.bidding-message  {
  .link-content-inner-container>.content {
    margin-top: 0px;
  }
  .out-container {
    .has-gutter {
      display: none;
    }
    .el-table {
      border-radius: 0px;
    }
  }
}
</style>
